import SlideFirst from './SlideFirst'

export default SlideFirst
// eslint-disable-next-line import/export
export * from './SlideFirst'
